// Table sorter
 function sortTable(table, col, reverse) {
    var tb = table.tBodies[0], // use `<tbody>` to ignore `<thead>` and `<tfoot>` rows
        tr = Array.prototype.slice.call(tb.rows, 0), // put rows into array
        i;
    reverse = -((+reverse) || -1);
    tr = tr.sort(function (a, b) { // sort rows
        return reverse // `-1 *` if want opposite order
            * (a.cells[col].textContent.trim() // using `.textContent.trim()` for test
                .localeCompare(b.cells[col].textContent.trim())
               );
    });
    for(i = 0; i < tr.length; ++i) tb.appendChild(tr[i]); // append each row in order
  }

  function makeSortable(table) {
    var th = table.tHead, i;
    th && (th = th.rows[0]) && (th = th.cells);
    if (th) i = th.length;
    else return; // if no `<thead>` then do nothing
    while (--i >= 0) (function (i) {
        var dir = 1;
        th[i].addEventListener('click', function () {sortTable(table, i, (dir = 1 - dir))});
    }(i));
  }
  function makeAllSortable(parent) {
      parent = parent || document.body;
      var t = parent.getElementsByTagName('table'), i = t.length;
      while (--i >= 0) makeSortable(t[i]);
  }
// END SORT TABLE

(function ($) {
  window.onload = function () {makeAllSortable();};

  let get_strong_action = $(".getStrong");
  let strong_drawer = $(".drawer");
  let strong_close = $(".close");

  if (get_strong_action != undefined) {
    // get_strong_action.on('click', (event) => {
    //     event.preventDefault();
    //     if ( strong_drawer != undefined ) {
    //         strong_drawer.addClass('showDrawer')
    //         $('.cls').addClass('modal-open')
    //     }
    // })
  }

  if (strong_close != undefined) {
    strong_close.on("click", (event) => {
      event.preventDefault();
      strong_drawer.removeClass("showDrawer");
      $(".cls").removeClass("modal-open");
    });
  }

  // Recover account credentials
  const pwd = $(".pwd");
  const pwdform = $(".pwd-form");

  const ambstrong = $(".ambstrong");
  const strongNum = $(".ambstrong-form");

  if (pwd != undefined && pwdform != undefined) {
    pwd.on("click", (e) => {
      pwdform.removeClass("pwd-form");
      pwdform.addClass("show");
      pwd.addClass("active");

      strongNum.removeClass("show").addClass("ambstrong-form");
      ambstrong.removeClass("active");
    });
  }

  if (ambstrong != undefined && strongNum != undefined) {
    ambstrong.on("click", (e) => {
      strongNum.removeClass("ambstrong-form");
      strongNum.addClass("show");
      ambstrong.addClass("active");

      pwdform.removeClass("show").addClass("pwd-form");
      pwd.removeClass("active");
    });
  }

  // Close Recovery Button
  const closeRecovery = $(".close-recovery");
  const recovery = $(".recovery");
  const signInIssues = $(".signin-issues");

  closeRecovery.on("click", (e) => {
    recovery.removeClass("open");
    $(".cls").removeClass("modal-open");
  });

  signInIssues.on("click", (e) => {
    e.preventDefault();
    recovery.addClass("open");
    $(".cls").addClass("modal-open");
  });

  // Domains
  // let request_root = "https://cid.ambacitizens.com";
  let request_root = "http://localhost:9999";
  // let request_root = 'https://ae16a13f.ngrok.io/'

  // STRONG NUMBER CREATION
  const strong_form = $("#ambastrongform");

  // SIGN IN
  let signin_form = $(".form-signin");
  signin_form.on("submit", function (e) {
    e.preventDefault();
    let username = $(".ambastrong");
    let password = $(".password");
    !username.val()
      ? username.addClass("error").focus()
      : username.addClass("ok");
    !password.val()
      ? password.addClass("error").focus()
      : password.addClass("ok");

    if (username.val() && password.val()) {
      let submit_btn = $(".sbtn");
      $.ajax(request_root + "/citizen/signin", {
        method: "POST",
        data: signin_form.serialize(),
        beforeSend: function () {
          // Show loader
          submit_btn.attr("disabled", "disabled").text("Working...");
          $(".load").addClass("show").html('<p class="loader"></p>');
        },
        success: function (data) {
          if (data.status) {
            $(".loader").removeClass("loader");
            e.target.reset();
            submit_btn.attr("disabled", false).text("Sign In");
            $(".notice")
              .removeClass("danger")
              .addClass("panel suceess")
              .text(data.message);
            // redirect
            window.location.replace(request_root + data.redirect);
          } else {
            // re-insert csrf keys
            let name = $(".csrf_name1");
            let value = $(".csrf_value1");
            name.attr("value", data.csrf.name);
            value.attr("value", data.csrf.value);
            $(".notice").addClass("panel danger").text(data.message);
            $(".loader").removeClass("loader");
            submit_btn.attr("disabled", false).text("Sign In");
          }
        },
      });
    }
  });

  var displayError = $(".info");
  var form = $("#payment-form");

  // STRIPE CARD PROCESSING
  // const stripe = Stripe("pk_live_51LkbwBFZbm2hHhY12cCoDFd0KfSZ78kIT1HgYHymJ1p4TGusH8hdz32SkS77L2Bm52IuWVxeEY8HEcWDjfig0Fee00KenZPRve");
  const stripe = Stripe("pk_test_51LkbwBFZbm2hHhY1hezS4AkkiCfpdn84tBUhqb8bEuWb8TvogMAW7Zh4cUASjkQH8oE7M0LTFCRbCzeOl6fRwLtg00aprkWEGQ");
  var elements = stripe.elements();

  // Create Card Form
  if (form.length) {
    // Custom styling can be passed to options when creating an Element.
    var style = {
      base: {
        fontSize: "19px",
        color: "#cfd6de",
        "::placeholder": {
          color: "#aab7c4",
        },
        ":-webkit-autofill": {
          color: "#32325d",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
        ":-webkit-autofill": {
          color: "#fa755a",
        },
      },
      complete: {
        color: "green",
        fontWeight: "bold",
      },
    };
    // Create instances of the card Element.
    var card = elements.create("cardNumber", {
      style: style,
      placeholder: "Card Number",
    });
    card.mount("#number");

    var ccv = elements.create("cardCvc", { style: style });
    ccv.mount("#ccv");

    var exp = elements.create("cardExpiry", { style: style });
    exp.mount("#exp");

    console.log(card.mount("#number"))
  }

  // SWITCH
  if ($(".yesorno") != null) {
    let cardoptions = Array.from(document.querySelectorAll(".yesorno"));
    let donation = document.querySelector(".donations");
    let subs = document.querySelector(".subs");
    let draft = document.querySelector(".draft");
    let arfee = document.querySelector(".arfee");

    cardoptions.forEach(function (button, index) {
      button.addEventListener("click", function (e) {
        cardoptions.forEach(function (bouton, i) {
          bouton.classList.remove("active");
        });
        button.classList.add("active");
        let sect = button.getAttribute("data-id");

        switch (sect) {
          case "uno":
            subs.classList.add("show");
            subs.classList.remove("hide");
            donation.classList.add("hide");
            donation.classList.remove("show");
            draft.classList.add("hide");
            draft.classList.remove("show");
            arfee.classList.add("hide");
            arfee.classList.remove("show");
            break;
          case "dos":
              if ($(".incog").val() != 1) {
                $("#card_donation_email").hide();
              }
              subs.classList.add("hide");
              subs.classList.remove("show");
              donation.classList.add("show");
              donation.classList.remove("hide");
              draft.classList.add("hide");
              draft.classList.remove("show");
              arfee.classList.add("hide");
              arfee.classList.remove("show");
            break;
          case "tres":
              subs.classList.add("hide");
              subs.classList.remove("show");
              donation.classList.add("hide");
              donation.classList.remove("show");
              draft.classList.add("show");
              draft.classList.remove("hide");
              arfee.classList.add("hide");
              arfee.classList.remove("show");
            break;
          case "quatro":
              subs.classList.add("hide");
              subs.classList.remove("show");
              donation.classList.add("hide");
              donation.classList.remove("show");
              draft.classList.add("hide");
              draft.classList.remove("show");
              arfee.classList.add("show");
              arfee.classList.remove("hide");
            break;
        }
      });
    });
  }

  // Card Form Submit
  $(".cbtn").on("click", function (e) {
    // check if we are dealing
    //  with donations or subscription
    let witch = $(".active");
    let witch_form = witch.attr("data-id");
    // Subscription fields
    let amount = $(".amount").val();
    let name = $(".name").val();
    let email = $(".email").val();
    let recurring = $(".recurring").val();
    let submit_btn = $(".cbtn");
    var incognito = $(".incog").val();
    var lga = $(".beneficiary_cid").val();

    if ($(".incog").length) {
      var incognito = $(".incog").val();
    } else {
      var incognito = 0;
    }

    if (witch_form == "uno") {
      // verify if name and plans are not empty
      // if ((lga == undefined || lga == "") && incognito == 1) {
      //   // console.log(incognito);
      //   // $(".notice").addClass("panel danger").html("Kindly choose your LGA.");
      //   return;
      // } else {
      //   $(".notice").removeClass("panel danger");
      // }

      // if (amount <= 0 || amount == "") {
      //   $(".notice").addClass("panel danger").html("Kindly choose an amount.");
      //   return;
      // } else {
      //   $(".notice").removeClass("panel danger");
      // }

      // if (name == undefined || name == "") {
      //   $(".notice")
      //     .addClass("panel danger")
      //     .html("Kindly provide the name on the card.");
      //   return;
      // } else {
      //   $(".notice").removeClass("panel danger");
      // }

      // if (recurring == undefined || recurring == "") {
      //   $(".notice")
      //     .addClass("panel danger")
      //     .html("Kindly choose your donation frequency.");
      //   return;
      // } else {
      //   $(".notice").removeClass("panel danger");
      // }

      // Card data to request stripe token
      var cardData = {
        name: $(".name").val(),
      };
      var data = stripe.createToken(card, cardData).then(function (result) {
        if (result.error && result.error.message) {
          $(".notice").addClass("panel danger").html(result.error.message);
        } else {
          $(".notice").removeClass("panel warning").text("");
          // Add the token to the form
          $(".stripeToken").attr("value", result.token.id);

          // Site form action link to donation
          $("#payment-form").attr(
            "action",
            request_root + "/citizen/dashboard/subscribe"
          );
          // Submit form
          $("#payment-form").submit();
          // make ajax call
          // $.ajax(request_root + "/citizen/dashboard/subscribe", {
          //   method: "POST",
          //   data: {
          //     stripeToken: result.token.id,
          //     plan: amount,
          //     name: name,
          //     lga: lga,
          //     recurring: recurring,
          //     incognito: incognito,
          //     email: email,
          //     csrf_name: $(".csrf_name").val(),
          //     csrf_value: $(".csrf_value").val(),
          //   },
          //   beforeSend: function () {
          //     // Show loader
          //     submit_btn
          //       .attr("disabled", "disabled")
          //       .text("")
          //       .text("Processing...");
          //   },
          //   success: function (data) {
          //     if (data.status) {
          //       $(".notice")
          //         .text("")
          //         .text(data.message)
          //         .removeClass("panel info danger")
          //         .addClass("panel success");
          //       e.target.reset();
          //       submit_btn.attr("disabled", false).text("Pay Now");
          //     } else {
          //       // re-insert csrf keys
          //       let name = $(".csrf_name");
          //       let value = $(".csrf_value");
          //       name.attr("value", data.csrf.name);
          //       value.attr("value", data.csrf.value);
          //       $(".notice").addClass("panel danger").text(data.message);
          //       submit_btn.attr("disabled", false).text("Pay Now");
          //     }
          //   },
          // });
        }
      });
    }else if(witch_form == "tres"){

       // Get variables
      let card_draft_amount = $(".card_draft_amount").val();
      // let card_draft_beneficiary_lga = $(".card_draft_beneficiary_lga").val();
      // let card_draft_purpose = $(".card_draft_purpose").val();
      var card_draft_email = $(".card_draft_email").val();

      // AMOUNT not empty
      if (card_draft_amount == undefined || card_draft_amount == "") {
        $(".notice").addClass("panel danger").html("Kindly choose your payment amount.");
        return;
      } else {
        $(".notice").removeClass("panel danger");
         $(".notice").hide();
      }

      // LGA not empty
      // if (card_draft_beneficiary_lga == undefined || card_draft_beneficiary_lga == "") {
      //   $(".notice").addClass("panel danger").html("Kindly choose your LGA.");
      //   return;
      // } else {
      //   $(".notice").removeClass("panel danger");
      // }

      // EMAIL not empty
      if (card_draft_email == undefined || card_draft_email == "") {
        $(".notice")
          .addClass("panel danger")
          .html("Kindly indicate your email to receive your payment invoice.");
        return;
      } else {
        $(".notice").removeClass("panel danger");
         $(".notice").hide();
      }

      // Card data to request stripe token
      var cardData = {
        name: card_draft_email,
      };
      // Stripe token
      var data = stripe.createToken(card, cardData).then(function (result) {
        if (result.error && result.error.message) {
          $(".notice").addClass("panel warning").html(result.error.message);
          return;
        } else {
          $(".notice").removeClass("panel warning").text("");
           $(".notice").hide();

          // Add the token to the form
          $(".stripeToken").attr("value", result.token.id);

          // Ste form action link to donation
          $("#payment-form").attr(
            "action",
            request_root + "/citizen/dashboard/act"
          );
          // Submit form
          $("#payment-form").submit();
        }
      });

    } else if(witch_form == "quatro"){ // AR FEE
      
       // Get variables
      let card_arfee_amount = $(".card_arfee_amount").val();
      let card_arfee_beneficiary_lga = $(".card_arfee_beneficiary_lga").val();
      let card_arfee_purpose = $(".card_arfee_purpose").val();
      var card_arfee_email = $(".card_arfee_email").val();

      // AMOUNT not empty
      if (card_arfee_amount == undefined || card_arfee_amount == "") {
        $(".notice").addClass("panel danger").html("Kindly choose your payment amount.");
        return;
      } else {
        $(".notice").removeClass("panel danger");
      }

      // LGA not empty
      if (card_arfee_beneficiary_lga == undefined || card_arfee_beneficiary_lga == "") {
        $(".notice").addClass("panel danger").html("Kindly choose your LGA.");
        return;
      } else {
        $(".notice").removeClass("panel danger");
      }

      // EMAIL not empty
      if (card_arfee_email == undefined || card_arfee_email == "") {
        $(".notice")
          .addClass("panel danger")
          .html("Kindly indicate your email to receive your payment invoice.");
        return;
      } else {
        $(".notice").removeClass("panel danger");
      }

      // Card data to request stripe token
      var cardData = {
        name: card_arfee_email,
      };
      // Stripe token
      var data = stripe.createToken(card, cardData).then(function (result) {
        if (result.error && result.error.message) {
          $(".notice").addClass("panel warning").html(result.error.message);
          return;
        } else {
          $(".notice").removeClass("panel warning").text("");

          // Add the token to the form
          $(".stripeToken").attr("value", result.token.id);

          // Ste form action link to donation
          $("#payment-form").attr(
            "action",
            request_root + "/citizen/dashboard/arfee"
          );
          // Submit form
          $("#payment-form").submit();
        }
      });
    }else {  // It's a DONATION
      // Get variables
      let card_donation_amount = $(".card_donation_amount").val();
      let card_donation_beneficiary_lga = $(
        ".card_donation_beneficiary_lga"
      ).val();
      let card_donation_purpose = $(".card_donation_purpose").val();
      var card_donation_email = $(".card_donation_email").val();
      var incognito = $(".incog").val();

      // check incognito mode
      if ($(".incog").length) {
        var incognito = $(".incog").val();
      } else {
        var incognito = 0;
      }

      // Check amount
      if (card_donation_amount <= 0 || card_donation_amount == "") {
        $(".notice").addClass("panel danger").html("Kindly enter an amount.");
        return;
      } else {
        $(".notice").removeClass("panel danger");
      }

      // Check lga to benefit
      if (
        card_donation_beneficiary_lga == undefined ||
        card_donation_beneficiary_lga == ""
      ) {
        $(".notice")
          .addClass("panel danger")
          .html("Kindly select a beneficiary to donate to.");
        return;
      } else {
        $(".notice").removeClass("panel danger");
      }

      // Check donor email
      if (card_donation_email == undefined || card_donation_email == "") {
        $(".notice")
          .addClass("panel danger")
          .html("Kindly indicate your email to receive your payment invoice.");
        return;
      } else {
        $(".notice").removeClass("panel danger");
      }

      // Card data to request stripe token
      var cardData = {
        name: card_donation_email,
      };
      // Stripe token
      var data = stripe.createToken(card, cardData).then(function (result) {
        if (result.error && result.error.message) {
          $(".notice").addClass("panel warning").html(result.error.message);
          return;
        } else {
          $(".notice").removeClass("panel warning").text("");

          // Add the token to the form
          $(".stripeToken").attr("value", result.token.id);

          // Ste form action link to donation
          $("#payment-form").attr(
            "action",
            request_root + "/citizen/dashboard/donate"
          );
          // Submit form
          $("#payment-form").submit();
        }
      });
    }

  });

  // Create ACH form
  var ach_form = $("#ach-payment-form");
  var ach_verify_form = $("#ach-verify-form");

  ach_form.on("submit", (event) => {
    event.preventDefault();
    let info = $(".achinfo");
    let submit_btn = $(".vfy");
    if (
      $(".acctype").val() == "" ||
      undefined == $(".acctype").val() ||
      $(".holdername").val() == "" ||
      undefined == $(".holdername").val() ||
      $(".accnumber").val() == "" ||
      undefined == $(".accnumber").val() ||
      $(".routing").val() == "" ||
      undefined == $(".routing").val()
    ) {
      info.text("").addClass("panel danger").html("All fields are required.");
      return;
    }
    let name = $(".csrf_name");
    let value = $(".csrf_value");
    // make ajax call
    $.ajax(request_root + "/citizen/dashboard/ach", {
      method: "POST",
      data: {
        acctype: $(".acctype").val(),
        holdername: $(".holdername").val(),
        accnumber: $(".accnumber").val(),
        routing: $(".routing").val(),
        csrf_name: $(".csrf_name").val(),
        csrf_value: $(".csrf_value").val(),
      },
      beforeSend: function () {
        // Show loader
        submit_btn.attr("disabled", "disabled").text("").text("Sending...");
      },
      success: function (response) {
        if (response.status) {
          ach_form.addClass("hide");
          ach_verify_form.removeClass("hide");
          $(".csrf_name2").attr("value", response.csrf.name);
          $(".csrf_value2").attr("value", response.csrf.value);
          // console.log($('.csrf_name2').val())
          // console.log($('.csrf_value2').val())
          info
            .text("")
            .text(response.message)
            .removeClass("panel info danger")
            .addClass("panel success");
          event.target.reset();
          submit_btn.attr("disabled", false).text("Verify Account");
        } else {
          // re-insert csrf keys

          name.attr("value", response.csrf.name);
          value.attr("value", response.csrf.value);
          info.addClass("panel danger").text(response.message);
          submit_btn.attr("disabled", false).text("Verify Account");
        }
      },
    });
  });

  // Confirm micro deposits
  ach_verify_form.on("submit", (event) => {
    event.preventDefault();
    const amount1 = $(".amount1").val();
    const amount2 = $(".amount2").val();
    const amount22 = $(".amount22").val();
    const recurring2 = $(".recurring2").val();
    const payment_type = $('input[name="ptypes"]:checked').val();
    const beneficiary = $(".ach_beneficiary").val();
    console.log(payment_type);
    let info = $(".achinfo");
    if (
      amount1 == "" ||
      undefined == amount1 ||
      amount2 == "" ||
      undefined == amount2 ||
      amount22 == "" ||
      undefined == amount22 ||
      recurring2 == "" ||
      undefined == recurring2
    ) {
      info
        .text("")
        .addClass("panel danger")
        .html("The two amounts are required.");
      return;
    }
    let name = $(".csrf_name");
    let value = $(".csrf_value");
    let submit_btn = $(".confirm");
    var incognito = $(".incog").val();
    if ($(".incog").length) {
      var incognito = $(".incog").val();
    } else {
      var incognito = 0;
    }

    $.ajax(request_root + "/citizen/dashboard/ach-verify", {
      method: "POST",
      data: {
        amount1: amount1,
        amount2: amount2,
        amount22: amount22,
        recurring2: recurring2,
        paymenttype: payment_type,
        beneficiary: beneficiary,
        incognito: incognito,
        csrf_name: $(".csrf_name2").val(),
        csrf_value: $(".csrf_value2").val(),
      },
      beforeSend: function () {
        // Show loader
        submit_btn.attr("disabled", "disabled").text("").text("Working...");
      },
      success: function (response) {
        if (response.status) {
          ach_form.addClass("hide");
          ach_verify_form.removeClass("hide");
          info
            .text("")
            .text(response.message)
            .removeClass("panel info danger")
            .addClass("panel success");
          event.target.reset();
          submit_btn.attr("disabled", false).text("Confirm & Pay");
        } else {
          // re-insert csrf keys

          $(".csrf_name2").attr("value", response.csrf.name);
          $(".csrf_value2").attr("value", response.csrf.value);
          info.addClass("panel danger").text(response.message);
          submit_btn.attr("disabled", false).text("Confirm & Pay");
        }
      },
    });
  });

  // SOFORT INTEGRATION
  var sofort_form = $("#sof-payment-form");
  sofort_form.on("submit", (event) => {
    event.preventDefault();
    if ($(".yesorno") != null) {
      let payment_type = Array.from(document.querySelectorAll(".ptype"));
      // console.log(payment_type);
      // .getAttribute('data-id')
    }
  });
  // SEPA INTEGRATION
  // Create an instance of the iban Element.
  // const stripe = Stripe('pk_test_MfIQuXtxhHPkiierOGmS8BGI00r1SJuIQE');
  var iban = elements.create("iban", {
    style: style,
    supportedCountries: ["SEPA"],
  });

  if ($("#iban-element").length > 0) {
    // Add an instance of the iban Element into the `iban-element` <div>.
    iban.mount("#iban-element");
  }

  var errorMessage = $("#error-message");
  var bankName = $("#bank-name");

  iban.on("change", function (event) {
    // Handle real-time validation errors from the iban Element.
    if (event.error) {
      errorMessage.text("").addClass("panel danger").html(event.error.message);
      errorMessage.addClass("visible");
    } else {
      errorMessage.text("").removeClass("visible panel danger");
    }

    // Display bank name corresponding to IBAN, if available.
    if (event.bankName) {
      bankName.text("").addClass("panel success").html(event.bankName);
      bankName.addClass("visible");
    } else {
      bankName.addClass("visible");
    }
  });

  // Handle form submission.
  var sepa_form = $("#sepa-payment-form");
  sepa_form.on("submit", function (event) {
    event.preventDefault();
    // showLoading();
    var sourceData = {
      type: "sepa_debit",
      currency: "eur",
      owner: {
        name: $(".sepname").val(),
        email: $(".sepemail").val(),
      },
      mandate: {
        // Automatically send a mandate notification email to your customer
        // once the source is charged.
        notification_method: "email",
      },
    };

    // Call `stripe.createSource` with the iban Element and additional options.
    stripe.createSource(iban, sourceData).then(function (result) {
      if (result.error) {
        // Inform the customer that there was an error.
        errorMessage
          .text("")
          .addClass("panel warning")
          .html(result.error.message);
        errorMessage.addClass("visible");
        // stopLoading();
      } else {
        errorMessage.removeClass("visible");
        // Send the Source to your server to create a charge.
        // ajax
        console.log(result.source);
        // stripeSourceHandler(result.source);
      }
    });
  });

  var registrations = [];
  function formatDate(date) {
    var dd = date.getDate();
    var mm = date.getMonth() + 1;
    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    date = mm + "/" + dd + "/" + yyyy;
    return date;
  }

  function Last7Days() {
    var result = [];
    for (var i = 0; i < 7; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i);
      result.push(formatDate(d));
    }
    return result.reverse();
    // return(result.join(','));
  }

  if ($("#myChart").length > 0) {
    $.ajax({
      url: request_root + "/control/lastseven",
      method: "GET",
      success: function (returnedData) {
        var days = Last7Days();
        var ctx = document.getElementById("myChart").getContext("2d");
        var chart = new Chart(ctx, {
          // The type of chart we want to create
          type: "line",

          // The data for our dataset
          data: {
            labels: days,
            datasets: [
              {
                label: "Registrations",
                borderColor: "rgb(255, 99, 132)",
                data: returnedData.reg,
              },
              {
                label: "# Of Payments",
                data: returnedData.pay,
                borderColor: [
                  "rgba(255, 99, 132, 1)",
                  "rgba(54, 162, 235, 1)",
                  "rgba(255, 206, 86, 1)",
                  "rgba(75, 192, 192, 1)",
                  "rgba(153, 102, 255, 1)",
                  "rgba(255, 159, 64, 1)",
                ],
                borderWidth: 1,
              },
            ],
          },

          // Configuration options go here
          options: {
            responsive: true,
            maintainAspectRatio: false,
          },
        });
      },
      error: function (data) {
        console.log(data);
      },
    });
  }

  // Modal for subscription plan details
  $("#exampleModal").on("show.bs.modal", function (event) {
    var button = $(event.relatedTarget); // Button that triggered the modal
    var plan = button.data("plan");
    var name = button.data("name");
    var modal = $(this);
    modal.find("#exampleModalLabel").text(name);
    // Make ajax request with plan data
    $.ajax(request_root + "/control/get-sub-plan/" + plan, {
      method: "GET",
      success: function (data) {
        // console.log(data)
        let price = parseInt(data.amount / 100);
        $(".name").html(data.nickname);
        $(".status").html(data.active);
        $(".price").html(price);
        $(".created").html(data.created);
      },
    });
  });

  //   CITIZENS SEARCH
  let input = $("#search");
  input.on(
    "propertychange input change onblur",
    throttle(function (arg) {
      $.ajax({
        url: request_root + "/control/citizens/search/" + input.val(),
        method: "GET",
        dataType: "json",
        success: function (data) {
          let template = "";
          let line = "";
          data.forEach(function (datum) {
            let line = `<tr>
                        <th scope="row"><a href="/control/citizens/profile/${datum.id}" title="View Profile | Joined on ${datum.created_at}">${datum.id}</a></th>
                        <td>${datum.firstname} ${datum.middlename} ${datum.lastname}</td>
                        <td>${datum.countryofresidence}</td>
                        <td>${datum.created_at}</td>
                    </tr>`;
            template += line;
          });

          $(".results").text("").html(template);
        },
        error: function (data) {
          $(".results")
            .text("")
            .html("Searching... <b>" + input.val() + "</b>");
        },
      });
    }, 1000)
  );

  function throttle(fn, wait) {
    var time = Date.now();
    return function () {
      if (time + wait - Date.now() < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  // Tables Sort
  if ($("#myTable").length > 0) {
    $("#myTable").tablesorter();
  }

  // Display total amount before submitting payment

  let les_montants = [0, 10, 25, 50, 75, 100, 30];
  let les_periodes = [0, 1, 3, 6, 12];
  let total_amount = $(".total_amount");

  function calculate_total_amount(montant, frequency) {
    // console.log(1, montant, frequency)
    return parseFloat(montant) * parseFloat(frequency);
  }
  // Display total Amount to pay
  $("#card_amount")
    .add("#card_recurring")
    .on("change touchend onblur", function (e) {
      // if(  $('.total_amount') != undefined ){
      let montant = les_montants[$("#card_amount").val()];

      let frequency = $("#card_recurring ").val();
      $(".total_amount")
        .text("")
        .html("$" + calculate_total_amount(montant, frequency))
        .addClass("inline-panel success");

      // }
    });

  // TOGGLE MENU
  let menu_toggle_button = $("#toggle-menu");
  let control_menu = $(".sidebar");
  menu_toggle_button.on("click", (e) => {
    e.preventDefault();
    control_menu.toggleClass("show_menu");
  });

  // Control states search
  let stat_periods = $(".state_periods");
  let custom_date_field = $(".custom_date_field");
  stat_periods.on('change', (e) => {
    let current = e.target.value;
    if(current == 7){
      custom_date_field.toggleClass("show");
    }else{
      custom_date_field.removeClass('show');
      custom_date_field.addClass('hide');
    }
  });
})(jQuery);
